// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.group-invite {
    text-align: center;
    width: 100%;
    max-width: 750px;
    margin: 0 auto 20px auto;
}
.group-invite__invitations {
    padding: 0 0 5px 0;
    font-size: 12px;
    font-style: italic;
}
.group-invite__input-wrapper {
    display: flex;
    position: relative;
}
.group-invite__suggestions-wrapper {
    display: flex;
    flex-grow: 1;
    position: relative;
    padding: 0;
    margin: 0;
}
.group-invite .group-invite__input-wrapper input[type=text] {
    display: inline-block;
    font-size: 16px;
    border-radius: 7px;
    flex-grow: 1
}
.group-invite__success {
    margin: 10px auto;
}
.group-invite .group-invite__suggestions {
    position: absolute;
    box-sizing: border-box;
    top: 38px;
    width: 100%;
    border: thin solid var(--main-border-color);
    padding: 10px;
    background-color: white;
    z-index: 1000;
}
.group-invite .group-invite__suggestions a {
    display: block;
    color: var(--primary-color-darkest);
    padding: 5px;
}
.group-invite .group-invite__suggestions a:hover {
    background-color: var(--primary-color-main);
    color: white;
}
.group-invite .group-invite__suggestions a.highlight {
    background-color: var(--primary-color-main);
    color: white;
}
    

`, "",{"version":3,"sources":["webpack://./client/components/groups/components/GroupInvite.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;IAClB,WAAW;IACX,gBAAgB;IAChB,wBAAwB;AAC5B;AACA;IACI,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,kBAAkB;AACtB;AACA;IACI,aAAa;IACb,YAAY;IACZ,kBAAkB;IAClB,UAAU;IACV,SAAS;AACb;AACA;IACI,qBAAqB;IACrB,eAAe;IACf,kBAAkB;IAClB;AACJ;AACA;IACI,iBAAiB;AACrB;AACA;IACI,kBAAkB;IAClB,sBAAsB;IACtB,SAAS;IACT,WAAW;IACX,2CAA2C;IAC3C,aAAa;IACb,uBAAuB;IACvB,aAAa;AACjB;AACA;IACI,cAAc;IACd,mCAAmC;IACnC,YAAY;AAChB;AACA;IACI,2CAA2C;IAC3C,YAAY;AAChB;AACA;IACI,2CAA2C;IAC3C,YAAY;AAChB","sourcesContent":[".group-invite {\n    text-align: center;\n    width: 100%;\n    max-width: 750px;\n    margin: 0 auto 20px auto;\n}\n.group-invite__invitations {\n    padding: 0 0 5px 0;\n    font-size: 12px;\n    font-style: italic;\n}\n.group-invite__input-wrapper {\n    display: flex;\n    position: relative;\n}\n.group-invite__suggestions-wrapper {\n    display: flex;\n    flex-grow: 1;\n    position: relative;\n    padding: 0;\n    margin: 0;\n}\n.group-invite .group-invite__input-wrapper input[type=text] {\n    display: inline-block;\n    font-size: 16px;\n    border-radius: 7px;\n    flex-grow: 1\n}\n.group-invite__success {\n    margin: 10px auto;\n}\n.group-invite .group-invite__suggestions {\n    position: absolute;\n    box-sizing: border-box;\n    top: 38px;\n    width: 100%;\n    border: thin solid var(--main-border-color);\n    padding: 10px;\n    background-color: white;\n    z-index: 1000;\n}\n.group-invite .group-invite__suggestions a {\n    display: block;\n    color: var(--primary-color-darkest);\n    padding: 5px;\n}\n.group-invite .group-invite__suggestions a:hover {\n    background-color: var(--primary-color-main);\n    color: white;\n}\n.group-invite .group-invite__suggestions a.highlight {\n    background-color: var(--primary-color-main);\n    color: white;\n}\n    \n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
